module.exports = __webpack_public_path__ + "static/media/login-step-3.9e2b6367.png";